<template>
    <div class="row">
        <div class="col-md-12">
            <div>
                <div class="overview-container" v-if="this.$store.state.applicationTemplateIds.length > 0">
                  <div :class="{ 'selected-overview' : isApplicationView }" @click="openApplicationView"> Applications Overview </div>
                  <div :class="{ 'selected-overview' : !isApplicationView }" @click="openVerificationView">Verifications Overview</div>
                  <div v-if="isApplicationView" class="select-container">
                    <ApplicationTemplateMultiSelect v-bind:defaultSelected="defaultSelected"/>
                  </div>
                </div>
                <!-- STATISTICS ROW -->
                <div class="top-grid-container">
                    <div class="stats" v-for="statistics in statsData" element-loading-spinner="qc-spinner" :loading="loadingOverviewData" v-loading="loadingOverviewData">
                        <div class="grid-container">
                            <div class="icon-holder center">
                                <i :class="statistics.icon"></i>
                            </div>
                            <div class="stats-container">
                                <p>{{ statistics.title }}</p>
                                <b>{{ statistics.value }}</b>
                                <br />
                                <el-tooltip class="item" effect="light" :content="'Previous ' + statistics.title.toLowerCase()">
                                  <span class="mini" tooltip-effect="light">
                                        <i class="fa fa-reply reply-icon"></i><span>{{ statistics.replyValue }}</span>
                                    </span>
                                  </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="center">
                        <button v-show="this.$store.state.hasReportsAccess" type="button" class="btn btn-wd btn-fill" @click="openReportDownloader">Download Reports</button>
                    </div>
                </div>
                <!-- FIRST GRAPH ROW -->
                <div class="graph-grid-container">
                    <div class="graph-container">
                        <div class="graph-heading-container">
                            <b>VOLUME</b>
                            <div>
                                <el-select v-model="volumeValue" @change="changeGraphName(volumeValue, 'volumeGraph')">
                                    <el-option v-for="option in mainOptions" :value="option" :label="option" :key="option.i">
                                    </el-option>
                                </el-select>
                                <el-tooltip class="item" effect="light" :content="'Download to spreadsheet format'">
                                    <i class="fa fa-lg fa-download download-icon" @click="downloadReports('volumeGraph')"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <hr />
                        <div class="chart-container" v-if="!volumeGraphLoading">
                            <VolumeGraph />
                        </div>
                    </div>
                    <div class="graph-container" v-if="shouldShowRevenue">
                        <div class="graph-heading-container">
                            <b>REVENUE SPEND (£)</b>
                            <div>
                                <el-select v-model="revenueValue" @change="changeGraphName(revenueValue, 'revenueGraph')">
                                    <el-option v-for="option in mainOptions" :value="option" :label="option" :key="option.i">
                                    </el-option>
                                </el-select>
                                <el-tooltip class="item" effect="light" :content="'Download to spreadsheet format'">
                                    <i class="fa fa-lg fa-download download-icon" @click="downloadReports('revenueGraph')"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <hr />
                        <div class="chart-container" v-if="!revenueGraphLoading">
                            <RevenueGraph />
                        </div>
                    </div>

                    <div class="graph-container" v-if="!shouldShowRevenue" >
                      <div class="graph-heading-container">
                        <b>VERIFICATIONS</b>
                        <div>
                          <el-select v-model="verificationsValue" @change="changeGraphName(verificationsValue, 'verificationsGraph')">
                            <el-option v-for="option in mainOptions" :value="option" :label="option" :key="option.i">
                            </el-option>
                          </el-select>
                          <el-tooltip class="item" effect="light" :content="'Download to spreadsheet format'">
                            <i class="fa fa-lg fa-download download-icon" @click="downloadReports('verificationsGraph')"></i>
                          </el-tooltip>
                        </div>
                      </div>
                      <hr />
                      <div class="chart-container">
                        <VerificationsGraph />
                      </div>
                    </div>
                </div>
                <!-- SECOND GRAPH ROW -->
                <div class="graph-grid-container">
                    <div class="graph-container" v-if="shouldShowRevenue">
                        <div class="graph-heading-container">
                            <b>VERIFICATIONS</b>
                            <div>
                                <el-select v-model="verificationsValue" @change="changeGraphName(verificationsValue, 'verificationsGraph')">
                                    <el-option v-for="option in mainOptions" :value="option" :label="option" :key="option.i">
                                    </el-option>
                                </el-select>
                                <el-tooltip class="item" effect="light" :content="'Download to spreadsheet format'">
                                    <i class="fa fa-lg fa-download download-icon" @click="downloadReports('verificationsGraph')"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <hr />
                        <div class="chart-container">
                            <VerificationsGraph />
                        </div>
                    </div>
                    <div class="graph-container">
                        <div class="graph-heading-container">
                            <div>
                                <b>COUNTRY STATISTICS</b>
                                <el-tooltip class="item" effect="light" :content="'You have completed verifications from ' + this.countryStatsDataLength + ' different countries'">
                                    <span>({{ countryStatsDataLength }})</span>
                                </el-tooltip>
                            </div>
                            <div>
                                <el-tooltip class="item" effect="light" :content="'Download to spreadsheet format'">
                                    <i class="fa fa-lg fa-download download-icon" @click="downloadReports('countryGraph')"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <hr />
                        <div class="chart-container" v-if="!countryGraphLoading" >
                            <CountryStatsGraph @update-count="updateCountryCount" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VolumeGraph from "./components/volumeGraph.vue";
import CountryStatsGraph from "./components/countryStatsGraph.vue"
import VerificationsGraph from "./components/verificationsBarGraph.vue"
import RevenueGraph from "./components/revenueSpendGraph.vue"
import ModalReportDownloader from 'src/components/ModalPlugin/ModalReportDownloader'
import ApplicationTemplateMultiSelect from "src/components/Inputs/ApplicationTemplateMultiSelect";

export default {
    components: {
        VolumeGraph,
        CountryStatsGraph,
        VerificationsGraph,
        RevenueGraph,
        ApplicationTemplateMultiSelect
    },
    data() {
        return {
            isApplicationView: false,
            defaultSelected: [],
            shouldShowRevenue: true,
            loadingOverviewData: true,
            verificationsData: null,
            overviewData: null,
            stateName: this.$store.state,
            countryGraphLoading: false,
            volumeGraphLoading: false,
            revenueGraphLoading: false,
            volumeValue: "Monthly (12)",
            revenueValue: "Monthly (12)",
            verificationsValue: "Monthly (12)",
            countryValue: "Top 5",
            mainOptions: [
                "Daily (30)",
                "Weekly (52)",
                "Monthly (12)",
                "Monthly (24)"
            ],
            statsData: [
                {
                    title: "DAILY COUNT",
                    value: null,
                    replyValue: null,
                    icon: "fa fa-calendar-check-o icon"
                },
                {
                    title: "WEEKLY COUNT",
                    value: null,
                    replyValue: null,
                    icon: "fa fa-calendar-minus-o icon"
                },
                {
                    title: "MONTHLY COUNT",
                    value: null,
                    replyValue: null,
                    icon: "fa fa-calendar icon"
                },
            ],
            countryStatsDataLength: 0,
        }
    },
    async mounted() {
        this.isApplicationView = false
        this.$store.state.selectedApplicationTemplateIds = []

        this.openApplicationView()

        this.setInitGraphNames()
        this.setOverviewData()
        this.getVerificationCountries()
    },
    methods: {
        openApplicationView () {
          if (this.isApplicationView === false) {

            this.isApplicationView = true
            this.shouldShowRevenue = !this.$store.state.applicationTemplateIds
              .map(template => { return template.paymentType })
              .includes('UPFRONT', 'APPLICANT')

            if(this.$store.state.applicationTemplateIds.length === 1) {
              this.defaultSelected = [this.$store.state.applicationTemplateIds[0].id]
              this.$store.state.selectedApplicationTemplateIds = [this.$store.state.applicationTemplateIds[0].id]
            } else {
              const templateIds = []
              this.$store.state.applicationTemplateIds.forEach(
                (template) => templateIds.push(template.id)
              )
              this.defaultSelected = templateIds;
              this.$store.state.selectedApplicationTemplateIds = templateIds;
            }

          }
        },
        openVerificationView() {
          if (this.isApplicationView === true) {
            this.isApplicationView = false
            this.defaultSelected = []
            this.$store.state.selectedApplicationTemplateIds = []
            this.shouldShowRevenue = true;
          }
        },
        openReportDownloader() {
            this.$modal.show(ModalReportDownloader);
        },
        downloadReports(graphName) {
            if(graphName == "volumeGraph") {
                this.$store.state.downloadVolumeSheet = true;
            }
            if(graphName == "revenueGraph") {
                this.$store.state.downloadRevenueSheet = true;
            }
            if(graphName == "verificationsGraph") {
                this.$store.state.downloadVerificationsSheet = true;
            }
            if(graphName == "countryGraph") {
                this.$store.state.downloadCountrySheet = true;
            }
        },
        getVerificationCountries() {
            this.$api.getCountryData(20, 12)
        },
        updateCountryCount(val) {
            this.countryStatsDataLength = val
        },
        setOverviewData() {
            this.$api.getOverviewData(this.isApplicationView ? this.$store.state.selectedApplicationTemplateIds : [])
                .then(response => {
                    this.overviewData = response.data
                    this.statsData[0].value = this.overviewData.day.first
                    this.statsData[0].replyValue = this.overviewData.day.second
                    this.statsData[1].value = this.overviewData.week.first
                    this.statsData[1].replyValue = this.overviewData.week.second
                    this.statsData[2].value = this.overviewData.month.first
                    this.statsData[2].replyValue = this.overviewData.month.second
                    this.loadingOverviewData = false
                }).catch(error => {
                    console.log(error)
                })
        },
        setInitGraphNames() {
            this.stateName.volumeChartName = this.volumeValue
            this.stateName.countryStatsChartName = this.countryValue.name
            this.stateName.revenueGraphChartName = this.revenueValue
            this.stateName.verificationsChartName = this.verificationsValue
            this.changeGraphName()
        },
        changeGraphName(val, name) {
            if (name == 'volumeGraph') {
                !this.volumeGraphLoading
                this.stateName.volumeChartName = val;
                !this.volumeGraphLoading
            }
            if (name == 'countryGraph') {
                !this.countryGraphLoading
                this.stateName.countryStatsChartName = val;
                !this.countryGraphLoading
            }
            if (name == 'revenueGraph') {
                !this.revenueGraphLoading
                this.stateName.revenueGraphChartName = val;
                !this.revenueGraphLoading
            }
            if (name == 'verificationsGraph') {
                !this.revenueGraphLoading
                this.stateName.verificationsChartName = val;
                !this.revenueGraphLoading
            }
        },
    },
  watch: {
    '$store.state.selectedApplicationTemplateIds': {
      deep: true,
      handler() {
        this.setOverviewData()
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.overview-container {
  display: flex;
  gap: 15px;
}

.overview-container > div {
  font-size: 18px;
  color: #3BA5AA;
  cursor: pointer;
}

.overview-container > div:hover {
  color: #28465A !important;
}

.selected-overview {
  text-decoration: underline;
  font-weight: 600;
  color: #28465A !important;
  cursor: default !important;
}

.select-container {
    margin: -10px 5px 0 5px;
    //margin: -20px 0 0 auto;
    //display: flex;
    //justify-content: end;
    //float: right;
}

.grid-container {
    display: grid;
    grid-template-columns: 1fr 3fr;
    height: 100%;
    border-radius: 5px;
}

.chart-container {
    position: relative;
    width: 35vw;
    min-width: 100%;
    margin-right: auto;
    margin-bottom: 5px;
}

.top-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 2rem;
    padding: 10px 0px 10px 0px;
    margin-bottom: 10px;
}

// USE BELOW TO STOP COUNT AND GRAPHS MOVING OUT OF SYNC AS SCREN SIZE CHANGES (NO IDEA WHY THIS HAPPENS)
.container-fluid {
    padding-right: 0px;
}

.graph-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
}

.graph-container {
    background-color: white;
    margin-bottom: 20px;
    border-radius: 6px;
    padding: 20px;
    padding-bottom: 10px;
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, .20);
}

.graph-heading-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.stats-container {
    background-color: white;
    margin: 10px 0px 5px 10px;
    font-size: 18px;
}

i {
    color: white;
}

.download-icon {
    margin-left: 5px;
    color: #3BA5AA;
    cursor: pointer;
}

.download-icon:hover {
    color: #359297
}

.btn-sm {
    margin-bottom: 5px;
}

.stats-container p {
    font-size: 14px;
}

.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.stats {
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, .20);
    background-color: white;
    color: black;
    font-size: 14px;
    border-radius: 5px;
}

.mini {
    font-size: 10px;
}

.icon {
    font-size: 3rem;
    width: 90px;
}

.reply-icon {
    color: black;
}

.icon-holder {
    background-color: #3BA5AA;
    border-right: 1px solid black;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

hr {
    margin-top: 10px;
}
// MEDIA QUERIES


@media only screen and (max-width: 1300px) {
    .graph-grid-container {
        grid-template-columns: 1fr;
        gap: 0px;
    }

    .top-grid-container {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
}

@media only screen and (max-width: 600px) {
    .top-grid-container {
        display: flex;
        flex-direction: column;
    }
    .top-grid-container :nth-child(1) {
        order: 2
    }
    .top-grid-container :nth-child(2) {
        order: 3
    }
    .top-grid-container :nth-child(3) {
        order: 4
    }
    .top-grid-container :nth-child(4) {
        order: 1
    }
}
</style>

